import API from "./api";

/**
 * Submit a new job to the backend.
 * @param {FormData} formData
 */
export const createJob = async (formData) => {
  return API.post("/store-jobs", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/**
 * Fetch paginated job reports with optional filters.
 *
 * @param {Object} params
 * @param {number}  params.page        - Current page (1-based)
 * @param {number}  params.per_page    - Rows per page
 * @param {string}  params.search      - Free-text search
 * @param {string}  params.status      - Status filter  ('all' | 'ongoing' | …)
 * @param {string}  params.staff_id    - Staff ID (admin only)
 * @param {string}  params.filter_type - Date range ('today'|'week'|'month'|'year'|'custom')
 * @param {string}  params.from_date   - Custom range start (YYYY-MM-DD)
 * @param {string}  params.to_date     - Custom range end   (YYYY-MM-DD)
 */
export const getJobs = async (params = {}) => {
  // Strip empty / null / undefined values so the URL stays clean
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  return API.get("/jobs-reports", { params: clean });
};